var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('GeneralScaffold',[_c('FormModelDisplay',{attrs:{"entity-repository":_vm.couponRepository,"embeds":_vm.embeds,"i18n-group":"coupon"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }